import ChangeEventType from '@/features/change-event-type';
import { DraggableModalWrapper } from '@/shared/ui';
import AddNewEvent from './addNewEvent';
import ChangeEventDuration from './changeEventDuration';
import EcgBookmarkTime from './ecgBookmarkTime';
import NewEvents from './newEvents';
import SwapTemplateModal from './swapTemplateModal';
import useBeatHRModal from './useBeatHRModal';

/**
 * Renders every draggable modal owned by the beats and HR tab: add new event, new events, change event duration, bulk change event type, add ECG bookmark and swap template. Reads the controlModal flags plus study, profile, timezone and ECG context from useBeatHRModal, toggles each wrapper's visibility from those flags and wires each modal's cancel handler back to the store.
 *
 * @returns The set of draggable modal wrappers for the beats tab, each shown only when its control flag is set.
 */
const BeatHRModal = () => {
  const {
    keyRecoil,
    controlModal,
    selectedStrip,
    selectedMultipleStrip,
    selectedEvent,
    studyId,
    profileId,
    timezone,
    startReport,
    timezoneOffset,
    stopReport,
    ecgDataMap,
    onClickCancelAddNewEvent,
    onClickCancelNewEvents,
    onClickCancelChangeEventTypeBulk,
    onClickCancelChangeEventDurationButtonType,
    onClickCancelChangeEventDurationSelectedInfo,
    isOpenTemplateModal,
  } = useBeatHRModal();

  return (
    <>
      {/* Button Add new event */}
      <DraggableModalWrapper visible={controlModal.isShowAddNewEvent} ariaLabel="Add new event">
        <AddNewEvent
          onCancel={onClickCancelAddNewEvent}
          studyId={studyId}
          profileId={profileId}
          timezone={timezone}
          timezoneOffset={timezoneOffset}
          ecgDataMap={ecgDataMap}
          startReport={startReport}
          stopReport={stopReport}
        />
      </DraggableModalWrapper>
      <DraggableModalWrapper visible={controlModal.isShowNewEvents} ariaLabel="New events">
        <NewEvents
          onCancel={onClickCancelNewEvents}
          studyId={studyId}
          profileId={profileId}
          timezoneOffset={timezoneOffset}
          ecgDataMap={ecgDataMap}
          startReport={startReport}
        />
      </DraggableModalWrapper>
      {/* Button Add new event */}
      {/* Button Type */}
      <DraggableModalWrapper
        visible={controlModal.isShowChangeDurationButtonType}
        ariaLabel="Change event duration"
      >
        <ChangeEventDuration
          onCancel={onClickCancelChangeEventDurationButtonType}
          timezone={timezone}
          timezoneOffset={timezoneOffset}
          ecgDataMap={ecgDataMap}
          studyId={studyId}
          profileId={profileId}
          selectedEvent={selectedStrip}
        />
      </DraggableModalWrapper>
      <DraggableModalWrapper
        visible={controlModal.isShowChangeTypeBulk}
        ariaLabel="Change event type"
      >
        <ChangeEventType
          keyRecoil={keyRecoil}
          onCancel={onClickCancelChangeEventTypeBulk}
          ecgDataMap={ecgDataMap}
          studyId={studyId}
          profileId={profileId}
          selectedStrip={selectedStrip}
          selectedMultipleStrip={selectedMultipleStrip}
        />
      </DraggableModalWrapper>
      {/* Button Type */}
      {/* Selected info option */}
      <DraggableModalWrapper
        visible={controlModal.isShowChangeDurationSelectedInfo}
        ariaLabel="Change event duration"
      >
        <ChangeEventDuration
          onCancel={onClickCancelChangeEventDurationSelectedInfo}
          timezone={timezone}
          timezoneOffset={timezoneOffset}
          ecgDataMap={ecgDataMap}
          studyId={studyId}
          profileId={profileId}
          selectedEvent={selectedEvent}
        />
      </DraggableModalWrapper>
      {/* Selected info option */}
      {/* Add ecg bookmark */}
      <DraggableModalWrapper
        visible={controlModal.isShowAddEcgBookmark}
        ariaLabel="Add ECG bookmark"
      >
        <EcgBookmarkTime timezone={timezone} ecgDataMap={ecgDataMap} />
      </DraggableModalWrapper>
      {/* Add ecg bookmark */}
      <DraggableModalWrapper
        visible={isOpenTemplateModal}
        className="swap-template-drag-modal-wrapper"
        ariaLabel="Swap template"
      >
        <SwapTemplateModal
          isOpen={isOpenTemplateModal}
          isSwapAllTemplate={(controlModal as any).isShowSwapAllTemplateByPage}
          isSwapAllTemplateById={(controlModal as any).isShowSwapAllTemplateById}
        />
      </DraggableModalWrapper>
    </>
  );
};

export default BeatHRModal;
